const ppl486Path = [
    {
        label: "IF",
        role: "IF",
        input: null,
        output: "IF/ID",
        latency: 1,
        canDelay: true
    },
    {
        label: "ID",
        role: "ID",
        input: "IF/ID",
        output: "ID/EX",
        latency: 1,
        canDelay: true
    },
    {
        label: "AG",
        role: "MEM",
        input: "ID/AG",
        output: "AG/ME",
        latency: 1,
        canDelay: true
    },
    {
        label: "MEX",
        role: "MEM,EX",
        input: "AG/MEX",
        output: "MEX/WB",
        latency: 1,
        canDelay: false
    },
    {
        label: "WB",
        role: "WB",
        input: "MEX/WB",
        output: null,
        latency: 1,
        canDelay: false
    }          
];

const ppl486 = {
    name: "Intel 80486",
    paths: {
        "int*": {
            phases: ppl486Path,
            opARequired: "MEX",
            opBRequired: "MEX",
            targetProvided: "MEX",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "mem*": {
            phases: ppl486Path,
            opARequired: "AG",
            opBRequired: "MEX",
            targetProvided: "MEX",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "jump*": {
            phases: ppl486Path,
            opARequired: "",
            opBRequired: "MEX",
            targetProvided: "",
            registerWriteBack: "",
            registerReadOut: "ID"         
        }
    },
    description: "Az Intel első pipeline-al rendelkező processzora, a 80486 is 5 fokozatú futószalaggal rendelkezett,"
    +" a fázisok azonban eltértek a tanult pipline fázisaitól. Az IF és az ID után egy AG (address generation) fázis"
    +" következett, ami a memóriakezelő utasítások számára címet számolt, az aritmetikai utasítások esetében pedig nem"
    +" csinált semmit. Az AG után a MEM/EX jön, ami memória load/store esetén elvégezte a tényleges memóriaműveletet"
    +" (az AG áltat számolt címre), aritmetikai utasítások esetén pedig magát az aritmetikai műveletet. Az utolsó fázis"
    +" itt is a WB, az eredmény visszaírása a regiszter tárolóba."
};

export default ppl486;